import { CourseTrainingOverviewPage } from "containers/CourseTrainingOverviewPage";
import { getReviews } from "shared-server/firebase";
import { getSingle, getDocs } from "shared/prismic";

export async function getStaticProps({ preview = null, previewData }) {
  async function getReviewsForUid(uid) {
    const reviews = await getReviews(uid);

    const reviewScores = (reviews || []).map(({ score }) =>
      parseInt(score, 10)
    );
    const reviewsAmount = reviewScores.length;
    const reviewsRating =
      reviewScores.reduce((a, b) => a + b, 0) / reviewsAmount;

    return { rating: reviewsRating, amount: reviewsAmount };
  }

  const doc = await getSingle({ previewData, type: "course_overview" });
  const items = await getDocs({ previewData, type: "course_detail" });

  await Promise.all(
    items.map(async (item, index) => {
      items[index].review = await getReviewsForUid(item.uid);
    })
  );

  return { props: { doc, items, preview, title: "Opleidingen" } };
}

export default CourseTrainingOverviewPage;
